import 'lib/vendor/snowplow';

const { snowplow: Snowplow } = window;

export default Snowplow;
